"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _react2 = require("@floating-ui/react");
var _reactIntl = require("react-intl");
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _handleKeyDown = _interopRequireDefault(require("@kiwicom/orbit-components/lib/utils/handleKeyDown"));
var _CountryFlag = _interopRequireDefault(require("@kiwicom/orbit-components/lib/CountryFlag"));
var _Check2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Check"));
var _Trip2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Trip"));
var _ChevronDown = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/ChevronDown"));
var _ChevronUp = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/ChevronUp"));
var _jsxRuntime = require("react/jsx-runtime");
var _Trip, _FormattedMessage, _Check;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DropdownTile = _ref => {
  let {
    title,
    flag = "",
    options,
    selected = false,
    selectedOptionId,
    global = false,
    onSelect,
    dropdownLabel
  } = _ref;
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const listRef = React.useRef([]);
  const {
    refs,
    floatingStyles,
    context
  } = (0, _react2.useFloating)({
    placement: global ? "right-end" : "bottom-start",
    open: isDropdownOpen,
    onOpenChange: setIsDropdownOpen,
    whileElementsMounted: _react2.autoUpdate,
    middleware: [(0, _react2.offset)(4), (0, _react2.size)({
      apply(_ref2) {
        let {
          rects,
          elements
        } = _ref2;
        Object.assign(elements.floating.style, {
          minWidth: `${rects.reference.width}px`
        });
      }
    }), (0, _react2.autoPlacement)({
      allowedPlacements: global ? ["right-end", "top-start"] : ["top-start", "bottom-start"]
    })]
  });
  const click = (0, _react2.useClick)(context);
  const dismiss = (0, _react2.useDismiss)(context);
  const role = (0, _react2.useRole)(context);
  const {
    getReferenceProps,
    getFloatingProps
  } = (0, _react2.useInteractions)([click, dismiss, role]);
  const Chevron = isDropdownOpen ? _ChevronUp.default : _ChevronDown.default;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _clsx.default)("relative rounded-300 border-2 py-300 px-400 cursor-pointer hover:shadow-level2 *:not-last:h-full", selected ? "border-blue-normal" : "border-cloud-normal hover:border-cloud-dark", !global && "col-span-1"),
    "data-test": global ? "region-global-tile" : "region-tile",
    ref: refs.setReference,
    role: "button",
    tabIndex: 0,
    ...getReferenceProps(),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
      direction: "row",
      align: "center",
      children: [flag && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CountryFlag.default, {
        code: flag,
        name: "",
        role: "presentation"
      }), global && (_Trip || (_Trip = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Trip2.default, {
        size: "small",
        ariaHidden: true
      }))), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
        spacing: "100",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          type: "primary",
          size: "normal",
          children: title
        }), !global && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          type: "secondary",
          size: "small",
          children: options.map(o => o.name).join(", ")
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Chevron, {
        size: "small"
      })]
    }), global && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "bg-cloud-light rounded-b-300 -mx-400 -mb-300 mt-300 px-400 py-300",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
        type: "secondary",
        size: "small",
        weight: "bold",
        children: [_FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.market_settings_modal.available_in"
        })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
          as: "span",
          type: "secondary",
          size: "small",
          children: [" ", options.map(o => o.name).join(", ")]
        })]
      })
    }), isDropdownOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.FloatingPortal, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.FloatingFocusManager, {
        context: context,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ref: refs.setFloating,
          className: "z-modal min-w-full tb:min-w-[max-content] rounded-150 shadow-level3 border border-cloud-normal bg-white-normal",
          style: {
            ...floatingStyles
          },
          "aria-label": dropdownLabel,
          ...getFloatingProps(),
          children: options.map((option, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "w-full flex justify-between p-300 cursor-pointer hover:bg-cloud-light not-last:border-b not-last:border-b-cloud-normal",
            "data-test": global ? "global-language-selector" : "language-selector",
            role: "option",
            ref: node => {
              listRef.current[index] = node;
            },
            "aria-selected": selectedOptionId === option.id,
            tabIndex: 0,
            onClick: () => onSelect(option),
            onKeyDown: (0, _handleKeyDown.default)(() => onSelect(option)),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              as: "span",
              size: "normal",
              children: option.name
            }), selectedOptionId === option.id && (_Check || (_Check = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Check2.default, {
              color: "info"
            })))]
          }, option.id))
        })
      })
    })]
  });
};
var _default = exports.default = DropdownTile;